export function validateName(name: string) {
  const regValidName = /(?=^.{2,}$)^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]*$/gm;

  return regValidName.test(name) && name.includes(' ')
}